<template>
    <div class="dropdown">
        <button class="badge btn btn-sm dropdown-toggle" data-toggle="dropdown" :class="badge">{{siteName}}</button>
        <div class="dropdown-menu">
            <a href="#" class="dropdown-item"
                v-for="(v, domain) in sites"
                :key="domain"
                @click.prevent="$emit('update:modelValue', domain)">
                {{v.name}}
            </a>
        </div>
    </div>
</template>

<script>
import novelSites from "@/novelSites";
export default {
    props: {
        url: {
            required: true
        },
        modelValue: {
            default: null,
        }
    },
    data() {
        return {
            sites: novelSites
        }
    },
    methods: {
        getSite() {
            let domain = this.getDomain();
            if (domain && this.sites[domain]) {
                return this.sites[domain];
            }
            return null;
        },
        getDomain() {
            if (this.modelValue) {
                return this.modelValue;
            }
            if (this.url) {
                let match = this.url.match(/https?:\/\/([^\/]+)\//);
                if (match) {
                    return match[1];
                }
            }
            return null;
        }
    },
    computed: {
        badge() {
            let site = this.getSite();
            if (site) {
                return {["badge-" + site.badge]: true};
            }
            return {"badge-dark": true};
        },
        siteName() {
            let site = this.getSite();
            if (site) {
                return site.name;
            }
            return this.getDomain();
        },
    },
}
</script>